// extracted by mini-css-extract-plugin
export default {"wrapper":"Video-module__wrapper___luRru","mediaContainer":"Video-module__mediaContainer___oU0w1","videoDescription":"Video-module__videoDescription___T8JCz"};